package cc.easyandroid.easycompose.component.router.stack

import cc.easyandroid.easycompose.component.Cancellation
import cc.easyandroid.easycompose.component.Relay
import cc.easyandroid.easycompose.component.router.stack.StackNavigation.Event

internal class DefaultStackNavigation<C : Any> : StackNavigation<C> {

    private val relay = Relay<Event<C>>()

    override fun navigate(transformer: (stack: List<C>) -> List<C>, onComplete: (newStack: List<C>, oldStack: List<C>) -> Unit) {
        relay.accept(Event(transformer, onComplete))
    }

    override fun subscribe(observer: (Event<C>) -> Unit): Cancellation =
        relay.subscribe(observer)
}
